import { plainToInstance, Type } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import {
  ISiteBoxDocumentPdfVersion,
  SiteBoxDocumentPdfVersion,
} from '@core/entities/SiteBoxDocumentPdfVersion'
import { ISiteBoxPlanDocument } from '@core/entities/SiteBoxPlanDocument'

export class SiteBoxPlanDocument extends Entity<ISiteBoxPlanDocument> {
  id: number
  name: string

  @Type(() => SiteBoxDocumentPdfVersion)
  currentVersion: SiteBoxDocumentPdfVersion

  public static new(payload: ISiteBoxDocumentPdfVersion) {
    const entity = plainToInstance(SiteBoxPlanDocument, payload)

    return entity
  }
}
